import React, { useEffect, useState } from "react";
import { Popover, notification } from "antd";
import moment from "moment";
import { AddToPlayListModalStyle } from "../AddToPlayListModal/AddToPlayListModal.style";
import { copyToClipboard } from "../../utils";
import { useLoginContext } from "../../context";
import CustomDateRangePickerDay from "./ShareScheduleCalender";
import axios from "axios";
import { BASE_URL } from "../../constants/api-urls";
import { useNavigate } from "react-router";

interface ShareModalProp {
  isModalVisible?: any;
  setIsModalVisible?: any;
  editType?: any;
  ViewDetailData?: any;
  setViewDetailData?: any;
  currentPlaylistData?: any;
  PlaylistRefreshRecord?: any;
  showCopyUrl?: any;
  scheduleSong?: any;
  detailLoader?: any;
}

function ShareModal({
  isModalVisible,
  setIsModalVisible,
  editType,
  ViewDetailData,
  setViewDetailData,
  currentPlaylistData,
  PlaylistRefreshRecord,
  showCopyUrl,
  scheduleSong,
  detailLoader,
}: ShareModalProp) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [notes, setNotes] = useState("");
  const [copied, setCopied] = useState(false);
  const { state: loginState } = useLoginContext();
  const [originalDate, setOriginalDate] = useState("");

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [shareUrlLoader, setShareUrlLoader] = useState(false);
  const navigate = useNavigate();
  const [url, setUrl] = useState("");

  const calculateOriginalDate = () => {
    // @ts-ignore
    const url = new URL(window.location);
    const originalDateLS = url.searchParams.get("originalDate");

    if (scheduleSong) {
      // For scheduled songs, prioritize ViewDetailData.start_time
      return originalDateLS
        ? originalDateLS
        : ViewDetailData?.start_time ||
          ViewDetailData?.started_time ||
          currentPlaylistData?.tracks?.items[0]?.added_at;
    } else {
      // For regular songs, use existing logic
      return originalDateLS
        ? originalDateLS
        : ViewDetailData?.added_at ||
          currentPlaylistData?.tracks?.items[0]?.added_at;
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
    if (setViewDetailData) {
      setViewDetailData("");
    }
  };
  const handleCancel = (e: any) => {
    e.stopPropagation();
    setIsModalVisible(false);
    if (setViewDetailData) {
      setViewDetailData("");
    }
    setOriginalDate("");
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (ViewDetailData?.notes) {
      setNotes(ViewDetailData.notes);
    } else {
      setNotes("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ViewDetailData?.notes]);

  useEffect(() => {
    // @ts-ignore
    const url = new URL(window.location);
    const originalDateLS = url.searchParams.get("originalDate");

    if (scheduleSong) {
      setOriginalDate(
        originalDateLS
          ? originalDateLS
          : PlaylistRefreshRecord?.length
          ? PlaylistRefreshRecord[0].addeddUri
            ? JSON.parse(PlaylistRefreshRecord[0]?.addeddUri).filter(
                (obj) => obj.uri === ViewDetailData?.song_uri
              ).length
              ? JSON.parse(PlaylistRefreshRecord[0]?.addeddUri).filter(
                  (obj) => obj.uri === ViewDetailData?.song_uri
                )[0]?.date
              : ViewDetailData?.start_time || ViewDetailData?.started_time
            : ViewDetailData?.start_time || ViewDetailData?.started_time
          : ViewDetailData?.start_time || ViewDetailData?.started_time
          ? ViewDetailData?.start_time || ViewDetailData?.started_time
          : currentPlaylistData?.tracks?.items[0]?.added_at
      );
    } else {
      setOriginalDate(
        originalDateLS
          ? originalDateLS
          : PlaylistRefreshRecord.length
          ? PlaylistRefreshRecord[0].addeddUri
            ? JSON.parse(PlaylistRefreshRecord[0]?.addeddUri).filter(
                (obj) => obj.uri === ViewDetailData?.track?.uri
              ).length
              ? JSON.parse(PlaylistRefreshRecord[0]?.addeddUri).filter(
                  (obj) => obj.uri === ViewDetailData?.track?.uri
                )[0]?.date
              : ViewDetailData?.added_at
            : ViewDetailData?.added_at
          : ViewDetailData?.added_at
          ? ViewDetailData?.added_at
          : originalDateLS || currentPlaylistData?.tracks?.items[0]?.added_at
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PlaylistRefreshRecord.length, ViewDetailData, scheduleSong]);

  useEffect(() => {
    if (isModalVisible) {
      if (ViewDetailData) {
        // Check if current URL already has track-detail
        if (window.location.pathname.includes("track-detail")) {
          return;
        }

        const uri =
          ViewDetailData?.song_uri ||
          ViewDetailData?.songUri ||
          ViewDetailData?.track?.uri;

        // Check if URI is empty or undefined
        if (!uri) {
          // Close the modal
          setIsModalVisible(false);
          if (setViewDetailData) {
            setViewDetailData("");
          }

          // Show error notification
          notification.error({
            message: false,
            description: (
              <div className="NotiDes" style={{ padding: "10px" }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="10" fill="white" />
                  <path
                    d="M12 13C12.2833 13 12.521 12.904 12.713 12.712C12.9043 12.5207 13 12.2833 13 12V7.975C13 7.69167 12.9043 7.45833 12.713 7.275C12.521 7.09167 12.2833 7 12 7C11.7167 7 11.4793 7.09567 11.288 7.287C11.096 7.479 11 7.71667 11 8V12.025C11 12.3083 11.096 12.5417 11.288 12.725C11.4793 12.9083 11.7167 13 12 13ZM12 17C12.2833 17 12.521 16.904 12.713 16.712C12.9043 16.5207 13 16.2833 13 16C13 15.7167 12.9043 15.479 12.713 15.287C12.521 15.0957 12.2833 15 12 15C11.7167 15 11.4793 15.0957 11.288 15.287C11.096 15.479 11 15.7167 11 16C11 16.2833 11.096 16.5207 11.288 16.712C11.4793 16.904 11.7167 17 12 17ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
                    fill="#FF3B30"
                  />
                </svg>
                Something went wrong while creating share link. Please try
                again.
              </div>
            ),
            placement: "top",
            style: {
              background: "rgb(28, 22, 54)",
              border: "2px solid #FF3B30",
              borderRadius: "8px",
              padding: "9px 16px",
              color: "white",
            },
            closeIcon: (
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.86858 8L11.9701 3.11094C12.0389 3.02969 11.9811 2.90625 11.8748 2.90625H10.628C10.5545 2.90625 10.4842 2.93906 10.4358 2.99531L7.05296 7.02813L3.67014 2.99531C3.62327 2.93906 3.55296 2.90625 3.47796 2.90625H2.23108C2.12483 2.90625 2.06702 3.02969 2.13577 3.11094L6.23733 8L2.13577 12.8891C2.12037 12.9072 2.11049 12.9293 2.1073 12.9529C2.10412 12.9764 2.10776 13.0004 2.11779 13.022C2.12783 13.0435 2.14383 13.0617 2.16392 13.0745C2.184 13.0872 2.20731 13.0939 2.23108 13.0938H3.47796C3.55139 13.0938 3.62171 13.0609 3.67014 13.0047L7.05296 8.97188L10.4358 13.0047C10.4826 13.0609 10.553 13.0938 10.628 13.0938H11.8748C11.9811 13.0938 12.0389 12.9703 11.9701 12.8891L7.86858 8Z"
                  fill="white"
                />
              </svg>
            ),
          });

          return;
        }

        let obj = {
          uri: uri,
          playlistId:
            ViewDetailData?.selected_playlist_id || currentPlaylistData?.id,
          id: ViewDetailData?.id,
          ref: loginState.refreshToken,
          position: ViewDetailData?.position,
          originalDate: calculateOriginalDate(),
          endTime: moment(ViewDetailData?.endTime).format("DD-MM-YY, hh:mm A"),
        };
        axios(`${BASE_URL}/createShareLinkToken/`, {
          data: obj,
          method: "post",
        }).then((res) => {
          setUrl(
            window?.location?.origin +
              "/track-detail?token=" +
              res.data.data.token
          );
        });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ViewDetailData, isModalVisible, currentPlaylistData?.id]);

  const getShareURL = () => {
    // setShareUrlLoader(true)
    setCopied(true);
    setShareUrlLoader(false);
    copyToClipboard(url);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <AddToPlayListModalStyle
      visible={isModalVisible}
      onOk={handleOk}
      footer={null}
      onCancel={handleCancel}
      className={`tractDetailShare`}
      style={
        showCopyUrl
          ? { maxWidth: "450px", width: "100%" }
          : detailLoader
          ? { maxWidth: "450px", width: "100%" }
          : { maxWidth: "945px", width: "100%" }
      }
    >
      <>
        <div className="viewDetailInner">
          {showCopyUrl ? (
            <>
              <h1
                className="heading"
                onClick={() => {
                  console.log(ViewDetailData);
                }}
              >
                Share song details
              </h1>
              <div className="note songURlCopy">
                <Popover
                  content={<span className="popSpan">{url}</span>}
                  placement="bottomLeft"
                >
                  <span
                    onClick={() => {
                      console.log(loginState, "loginStateloginState");
                    }}
                  >
                    {url}
                    {/* {window?.location?.origin +
                    "/track-detail?uri=" +
                    (ViewDetailData?.song_uri || currentPlaylistData?.uri) +
                    "&playlistId=" +
                    (ViewDetailData?.selected_playlist_id ||
                      currentPlaylistData?.id) +
                    "&id=" +
                    ViewDetailData?.id +
                    "&ref=" +
                    loginState.refreshToken +
                    "&originalDate=" +
                    originalDate +
                    "&endTime" +
                    moment(ViewDetailData.endTime).format("DD-MM-YY, hh:mm A")} */}
                  </span>
                </Popover>
                <Popover
                  overlayClassName="copyPop"
                  content={<p>{copied ? "Copied" : "Copy"}</p>}
                  placement="topLeft"
                >
                  <button className="copyUrlSong" onClick={getShareURL}>
                    Copy
                  </button>
                </Popover>
              </div>
            </>
          ) : (
            <>
              {detailLoader ? (
                <>
                  <div className="viewDetailInner">
                    <>
                      <div
                        className="addToPlaylistHead"
                        style={{ border: "none", padding: 0 }}
                      >
                        <h1 className="heading headingCenter">
                          {/* {"Song detail"} */}
                        </h1>
                      </div>
                      <div className="loadingDiv">
                        <div className="loadingCircle"></div>
                      </div>
                      <p className="refreshText" style={{ marginTop: "15px" }}>
                        {"Just a moment"}
                      </p>
                    </>
                  </div>
                </>
              ) : (
                <>
                  <img
                    className="logo-image shareSongLogo"
                    src="./static/songplace.png"
                    alt="songplace-logo"
                    width="254"
                    height="51"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate("/");
                    }}
                  />
                  <h1
                    className="heading"
                    onClick={() => {
                      console.log(ViewDetailData);
                    }}
                  >
                    Song details
                  </h1>
                  <div className="songDetailsInner">
                    <div className="songDetailTime">
                      <div className="songDetail">
                        <div className="albumDiv">
                          <img
                            alt={
                              ViewDetailData?.track?.name ||
                              ViewDetailData?.name
                            }
                            className="albumPic"
                            src={
                              ViewDetailData?.track?.album?.images[0]?.url ||
                              ViewDetailData?.album?.images[0]?.url
                            }
                          />
                          <div className="albumDetail">
                            <h3>
                              {ViewDetailData?.track?.name ||
                                ViewDetailData?.name}
                            </h3>
                            {ViewDetailData?.artists ||
                            ViewDetailData?.track?.artists[0]?.name ? (
                              <p>
                                {ViewDetailData?.track?.artists[0]?.name ||
                                  ViewDetailData?.artists[0]?.name}
                              </p>
                            ) : null}
                          </div>
                        </div>
                        <div className="dateDiv">
                          <div className="date">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.8889 0C16.5639 0 17.1111 0.547213 17.1111 1.22222V2.44444H19.5556C20.9056 2.44444 22 3.53886 22 4.88889V19.5556C22 20.9056 20.9056 22 19.5556 22H2.44444C1.09441 22 0 20.9056 0 19.5556V4.88889C0 3.53886 1.09441 2.44444 2.44444 2.44444H4.88889V1.22222C4.88889 0.547213 5.43609 0 6.11111 0C6.78613 0 7.33333 0.547213 7.33333 1.22222V2.44444H14.6667V1.22222C14.6667 0.547213 15.2139 0 15.8889 0ZM19.5556 4.88889H2.44444V19.5556H19.5556V4.88889ZM14.4517 7.79621C14.929 7.31891 15.7029 7.31891 16.1801 7.79621C16.6575 8.27352 16.6575 9.04738 16.1801 9.52466L10.1392 15.5657C9.65702 16.0478 8.87541 16.0478 8.39338 15.5657L5.8093 12.9817C5.33198 12.5043 5.33198 11.7305 5.8093 11.2531C6.2866 10.7758 7.06047 10.7758 7.53777 11.2531L9.26628 12.9817L14.4517 7.79621Z"
                                fill="white"
                              />
                            </svg>
                            {moment(originalDate).format(
                              "DD-MM-YY, hh:mm a"
                            ) === "Invalid date"
                              ? originalDate
                              : moment(originalDate).format(
                                  "DD-MM-YY, hh:mm a"
                                )}
                            {/* {originalDate} */}
                          </div>
                          <div className="dateText">{moment(originalDate).isAfter(moment()) ? 'Scheduled start time' : 'Original start date'}</div>
                        </div>
                        <div style={{ padding: "6px 32px" }}>
                          <svg
                            width="11"
                            height="33"
                            viewBox="0 0 11 33"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="5.20833"
                              cy="5.20833"
                              r="5.20833"
                              fill="#D9D9D9"
                            />
                            <circle
                              cx="5.125"
                              cy="19.125"
                              r="3.125"
                              fill="#D9D9D9"
                              fillOpacity="0.7"
                            />
                            <circle
                              cx="5.08333"
                              cy="30.0833"
                              r="2.08333"
                              fill="#D9D9D9"
                              fillOpacity="0.3"
                            />
                          </svg>
                        </div>
                        <div className="dateDiv">
                          <div className="date">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.8889 0C16.5639 0 17.1111 0.547213 17.1111 1.22222V2.44444H19.5556C20.9056 2.44444 22 3.53886 22 4.88889V19.5556C22 20.9056 20.9056 22 19.5556 22H2.44444C1.09441 22 0 20.9056 0 19.5556V4.88889C0 3.53886 1.09441 2.44444 2.44444 2.44444H4.88889V1.22222C4.88889 0.547213 5.43609 0 6.11111 0C6.78613 0 7.33333 0.547213 7.33333 1.22222V2.44444H14.6667V1.22222C14.6667 0.547213 15.2139 0 15.8889 0ZM19.5556 4.88889H2.44444V19.5556H19.5556V4.88889ZM14.4517 7.79621C14.929 7.31891 15.7029 7.31891 16.1801 7.79621C16.6575 8.27352 16.6575 9.04738 16.1801 9.52466L10.1392 15.5657C9.65702 16.0478 8.87541 16.0478 8.39338 15.5657L5.8093 12.9817C5.33198 12.5043 5.33198 11.7305 5.8093 11.2531C6.2866 10.7758 7.06047 10.7758 7.53777 11.2531L9.26628 12.9817L14.4517 7.79621Z"
                                fill="white"
                              />
                            </svg>
                            {ViewDetailData?.endTime
                              ? ViewDetailData?.endTime === "-"
                                ? "Not decided"
                                : moment(ViewDetailData?.endTime).format(
                                    "DD-MM-YY, h:mm a"
                                  )
                              : "Not decided"}
                          </div>
                          <div
                            className="dateText"
                            onClick={() => {
                              console.log(
                                ViewDetailData,
                                "ViewDetailDataViewDetailData"
                              );
                            }}
                          >
                            End date
                          </div>
                        </div>
                      </div>
                      <div className="calender">
                        <CustomDateRangePickerDay
                          ViewDetailData={ViewDetailData}
                          originalDate={originalDate}
                        />
                        {/* <DateRangePicker
      ranges={[selectionRange]}
      onChange={handleSelect}
    /> */}
                      </div>
                    </div>
                    <div className="playlistPositionDetail">
                      <div className="playlistPositionDiv">
                        <p>Playlist</p>
                        <p>{currentPlaylistData?.name}</p>
                      </div>
                      <div className="playlistPositionDiv">
                        <p>Position</p>
                        <p>
                          {Number(ViewDetailData?.position) >= 0
                            ? Number(ViewDetailData?.position)
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <p className="SongplaceText">
                    Get your music and playlists managed through Songplace.{" "}
                    <a href={window?.location?.origin} target="_blank" rel="noreferrer">
                      Learn more
                    </a>
                  </p>
                </>
              )}
            </>
          )}
        </div>
      </>
    </AddToPlayListModalStyle>
  );
}

export default ShareModal;
